import { useSellerPortalCategories } from 'hooks'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import type { Item, SellerPortalTreeItem } from 'typings'
import { MultiSelect } from '../../MultiSelect'
import { normalizeString } from '../../utils'

type Props = {
  name: string
}

function searchCategory(tree: SellerPortalTreeItem[], term: string) {
  const q = normalizeString(term)

  return tree.reduce<Item[]>((acc, item) => {
    let newAcc = [...acc]

    const normalizedName = item.value.name

    if (normalizedName.includes(q) || item.value.id === q) {
      newAcc.push({ name: item.value.name, id: item.value.id })
    }

    if (item.children) {
      newAcc = newAcc.concat(searchCategory(item.children, q))
    }

    return newAcc
  }, [] as Item[])
}

export function CategorySelector(props: Props) {
  const { formatMessage } = useIntl()
  const { name } = props
  const [searchTerm, setSearchTerm] = useState('')

  const { data: categoriesTree, isLoading } = useSellerPortalCategories()

  const options = useMemo(
    () => searchCategory(categoriesTree ?? [], searchTerm),
    [searchTerm, categoriesTree]
  )

  return (
    <MultiSelect
      name={name}
      options={options}
      label={formatMessage({
        id: 'admin/promotions.form.scope.categories.select.placeholder',
      })}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
    />
  )
}
